export const LAST_EDITED_USER_RATE_SET = 'at/panels/user/accountSettings/userRates/LAST_EDITED_USER_RATE_SET'
export const ERRORS_SET = 'at/panels/user/accountSettings/userRates/ERRORS_SET'
export const ERRORS_CLEAR = 'at/panels/user/accountSettings/userRates/ERRORS_CLEAR'
export const UPDATING_SET = 'at/panels/user/accountSettings/userRates/UPDATING_SET'



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/actionTypes.js